import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EgiRoutes } from '@ervo/page-framework';
import { SharedModule } from '@shared/shared.module';
import {
  ChartEnvironmentFullPageComponent
} from '@/app/egi.pages/human-design/chart.pages/chart-environment-full-page/chart-environment-full-page.component';
import {
  ChartManagerPageComponent
} from '@/app/egi.pages/human-design/chart.pages/chart-manager-page/chart-manager-page.component';
import {
  HdTransitsPageComponent
} from '@/app/egi.pages/human-design/transits.page/hd-transits-page.component';
import { HdEphemerisPageComponent } from '@/app/egi.pages/human-design/ephemeris.page/hd-ephemeris-page.component';
import { HdClassicIChingPageComponent } from '@/app/egi.pages/human-design/classic-iching.page/hd-classic-iching-page.component';
import {
  HdLifeTimelinePageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-life-timeline-page/hd-life-timeline-page.component';
import {
  HdExperimentPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-experiment-page/hd-experiment-page.component';
import {
  HdCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-cheat-sheet-page/hd-cheat-sheet-page.component';
import {
  HdPlanetCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-planet-cheat-sheet-page/hd-planet-cheat-sheet-page.component';
import {
  HdPlanetInfluenceCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-planet-influence-cheat-sheet-page/hd-planet-influence-cheat-sheet-page.component';
import {
  HdIchingCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-iching-cheat-sheet-page/hd-iching-cheat-sheet-page.component';
import {
  HdNotSelfCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-not-self-cheat-sheet-page/hd-not-self-cheat-sheet-page.component';
import {
  HdPhsIconCandidatesPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-phs-icon-candidates-page/hd-phs-icon-candidates-page.component';
import {
  HdPhsTransformationCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-phs-transformation-cheat-sheet-page/hd-phs-transformation-cheat-sheet-page.component';
import {
  HdStreamsCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-streams-cheat-sheet-page/hd-streams-cheat-sheet-page.component';
import {
  HdCyclesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-cycles-cheat-sheet-page/hd-cycles-cheat-sheet-page.component';
import {
  HdProfileLinesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-profile-lines-cheat-sheet-page/hd-profile-lines-cheat-sheet-page.component';
import {
  HdRoleGatesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-role-gates-cheat-sheet-page/hd-role-gates-cheat-sheet-page.component';
import {
  HdProfileRolesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-profile-roles-cheat-sheet-page/hd-profile-roles-cheat-sheet-page.component';
import {
  HdNodalLinesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-nodal-lines-cheat-sheet-page/hd-nodal-lines-cheat-sheet-page.component';
import {
  HdCommunicationCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-communication-cheat-sheet-page/hd-communication-cheat-sheet-page.component';
import {
  HdAwarenessCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-awareness-cheat-sheet-page/hd-awareness-cheat-sheet-page.component';
import {
  HdMelancholyCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-melancholy-cheat-sheet-page/hd-melancholy-cheat-sheet-page.component';
import {
  HdMemoryCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-memory-cheat-sheet-page/hd-memory-cheat-sheet-page.component';
import {
  HdMemoryCheatBlockComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-memory-cheat-sheet-page/hd-memory-cheat-block.component';
import {
  HdConditioningCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-conditioning-cheat-sheet-page/hd-conditioning-cheat-sheet-page.component';
import { HdConditioningCardComponent } from '@/app/human-design/chart/conditioning/hd-conditioning-card.component';
import {
  HdLoveGatesCheatSheetPageComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-love-gates-cheat-sheet-page/hd-love-gates-cheat-sheet-page.component';
import {
  HdLoveCheatCardComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-love-gates-cheat-sheet-page/hd-love-cheat-card.component';
import { HdFearCardComponent } from '@/app/human-design/chart/fears/hd-fear-card.component';
import { HdMelancholyCardComponent } from '@/app/human-design/chart/melancholy/hd-melancholy-card.component';
import {
  HdPhsTransformationBandComponent
} from '@/app/egi.pages/human-design/chart.pages/hd-phs-transformation-cheat-sheet-page/hd-phs-transformation-band/hd-phs-transformation-band.component';
import {
  HdNotSelfCardComponent
} from '@/app/human-design/chart/bodygraph/not-self/hd-not-self-card.component';
import { HdBodygraphChartComponent } from '@/app/human-design/chart/bodygraph/hd-bodygraph-chart/hd-bodygraph-chart.component';
import { HdBodygraphConfiguratorComponent } from '@/app/human-design/chart/bodygraph/hd-bodygraph-configurator/hd-bodygraph-configurator.component';
import {
  HdCheatSheetGridComponent
} from '@/app/human-design/chart/bodygraph/gate-info/cheat-sheet-grid/hd-cheat-sheet-grid.component';
import {
  HdCheatSheetControlsBarComponent
} from '@/app/human-design/chart/bodygraph/gate-info/cheat-sheet-controls-bar/hd-cheat-sheet-controls-bar.component';
import { HdPlanetCardComponent } from '@/app/human-design/chart/bodygraph/planet-info/hd-planet-card.component';
import {
  HdGateLineCardComponent
} from '@/app/human-design/chart/bodygraph/gate-info/line/hd-gate-line-card.component';
import {
  HdNodalLineCardComponent
} from '@/app/human-design/chart/bodygraph/nodal-lines/hd-nodal-line-card.component';

import {
  HD_CHART_ENVIRONMENT_PAGE_ID,
  HD_CLASSIC_ICHING_PAGE_ID,
  HD_EPHEMERIS_PAGE_ID,
  HD_LIFE_TIMELINE_CLICKTHROUGH_PAGE_ID,
  HD_LIFE_TIMELINE_PAGE_ID,
} from './hd-page-ids';
import { COMMUNITY_LINE_CONTENT_FEATURE_ID } from '@/app/human-design/community-content/community-content.metadata';
import { CLASSIC_ICHING_FEATURE_ID, CLASSIC_ICHING_WILHELM_NL_FEATURE_ID } from '@/app/human-design/iching/iching.metadata';
import { SHARE_CHARTS_FEATURE_ID } from '@/app/human-design/chart/library/hd-chart-share.models';
import { REVIEW_LINE_TEXTS_FEATURE_ID } from '@/app/human-design/line-text-review/hd-line-text-review.metadata';

const topic = 'Human Design';

@NgModule({
  declarations: [
    HdExperimentPageComponent,
    HdCheatSheetPageComponent,
    HdPlanetCheatSheetPageComponent,
    HdPlanetInfluenceCheatSheetPageComponent,
    HdIchingCheatSheetPageComponent,
    HdNotSelfCheatSheetPageComponent,
    HdPhsIconCandidatesPageComponent,
    HdPhsTransformationCheatSheetPageComponent,
    HdStreamsCheatSheetPageComponent,
    HdCyclesCheatSheetPageComponent,
    HdProfileLinesCheatSheetPageComponent,
    HdRoleGatesCheatSheetPageComponent,
    HdProfileRolesCheatSheetPageComponent,
    HdNodalLinesCheatSheetPageComponent,
    HdCommunicationCheatSheetPageComponent,
    HdAwarenessCheatSheetPageComponent,
    HdMelancholyCheatSheetPageComponent,
    HdMemoryCheatSheetPageComponent,
    HdConditioningCheatSheetPageComponent,
    HdLoveGatesCheatSheetPageComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ChartEnvironmentFullPageComponent,
    ChartManagerPageComponent,
    HdTransitsPageComponent,
    HdEphemerisPageComponent,
    HdClassicIChingPageComponent,
    HdLifeTimelinePageComponent,
    HdBodygraphChartComponent,
    HdBodygraphConfiguratorComponent,
    HdCheatSheetGridComponent,
    HdCheatSheetControlsBarComponent,
    HdPlanetCardComponent,
    HdGateLineCardComponent,
    HdNotSelfCardComponent,
    HdPhsTransformationBandComponent,
    HdFearCardComponent,
    HdMelancholyCardComponent,
    HdMemoryCheatBlockComponent,
    HdConditioningCardComponent,
    HdLoveCheatCardComponent,
    HdNodalLineCardComponent,
  ],
})
export class HdPagesModule {
  static readonly routes: EgiRoutes = [
    {
      path: 'chart-environment-full',
      component: ChartEnvironmentFullPageComponent,
      data: {
        config: {
          id: HD_CHART_ENVIRONMENT_PAGE_ID,
          name: 'ChartEnvironmentFull',
          // Levenstijdlijn als doorklikpagina: het beheer maakt hier een
          // child-navigatie-item van (met eigen rechten) en de breadcrumb
          // biedt de terugknop naar de chart (wens Steven, stap 5-naronde).
          // Verwijst naar de aparte doorklik-registratie hieronder; het
          // gewone menu-item blijft daarnaast bestaan.
          clickTroughPages: {
            lifeTimeline: { id: HD_LIFE_TIMELINE_CLICKTHROUGH_PAGE_ID, displayKey: '' },
          },
          features: {
            // Community-content (Line Companion e.d.): in UPAM per
            // gebruikersgroep toe te kennen; de check is app-breed
            // (CommunityContentAccessService), de declaratie leeft hier.
            communityLineContent: {
              id: COMMUNITY_LINE_CONTENT_FEATURE_ID,
              displayKey: 'communityLineContent',
            },
            // Classic I Ching: feature voor het onderdeel + pack-feature voor
            // de NL-Wilhelm-tekst; de check is app-breed (HdIChingAccessService).
            classicIChing: { id: CLASSIC_ICHING_FEATURE_ID, displayKey: 'classicIChing' },
            classicIChingWilhelmNl: { id: CLASSIC_ICHING_WILHELM_NL_FEATURE_ID, displayKey: 'classicIChingWilhelmNl' },
            // Charts delen via link: deelknoppen en het overzicht van gedeelde charts;
            // de check is app-breed (HdChartShareAccessService). Een deellink
            // bekijken blijft voor iedereen open.
            shareCharts: { id: SHARE_CHARTS_FEATURE_ID, displayKey: 'shareCharts' },
            // Eigen lijnteksten reviewen (goedkeuren/herschrijven in de gate-info +
            // reviewoverzicht); de check is app-breed (HdLineTextReviewAccessService).
            reviewLineTexts: { id: REVIEW_LINE_TEXTS_FEATURE_ID, displayKey: 'reviewLineTexts' },
          },
          topic,
        },
      },
    },
    {
      path: 'transits',
      component: HdTransitsPageComponent,
      data: {
        config: {
          id: '47fd3277-b2f2-4fb7-8e60-39b963b4c0d3',
          name: 'HdTransits',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      // Ephemeris in tabelvorm (spec 2026-10-13): menu-item via UPAM-beheer.
      path: 'ephemeris',
      component: HdEphemerisPageComponent,
      data: {
        config: {
          id: HD_EPHEMERIS_PAGE_ID,
          name: 'HdEphemeris',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      // Classic I Ching: raadpleegpagina (spec 2026-10-18). Menu-item via UPAM-beheer;
      // de pagina controleert zelf ook feature + setting (HdIChingAccessService).
      path: 'classic-iching',
      component: HdClassicIChingPageComponent,
      data: {
        config: {
          id: HD_CLASSIC_ICHING_PAGE_ID,
          name: 'HdClassicIChing',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'life-timeline',
      component: HdLifeTimelinePageComponent,
      data: {
        config: {
          id: HD_LIFE_TIMELINE_PAGE_ID,
          name: 'HdLifeTimeline',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      // Zelfde component als doorklikpagina onder de chart-omgeving (zie
      // hd-page-ids voor het waarom van de dubbele registratie).
      path: 'chart-timeline',
      component: HdLifeTimelinePageComponent,
      data: {
        config: {
          id: HD_LIFE_TIMELINE_CLICKTHROUGH_PAGE_ID,
          name: 'Levenstijdlijn',
          isClickThroughPage: true,
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'chart-manager',
      component: ChartManagerPageComponent,
      data: {
        config: {
          id: 'f1a2b3c4-d5e6-47a8-9b0c-1d2e3f405162',
          name: 'Chart manager',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'experiment',
      component: HdExperimentPageComponent,
      data: {
        config: {
          id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
          name: 'HdExperiment',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'cheat-sheet',
      component: HdCheatSheetPageComponent,
      data: {
        config: {
          id: 'b2c3d4e5-f678-9012-bcde-f23456789012',
          name: 'HdCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'planet-cheat-sheet',
      component: HdPlanetCheatSheetPageComponent,
      data: {
        config: {
          id: 'c3d4e5f6-7890-1234-cdef-345678901234',
          name: 'HdPlanetCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'planet-influence-cheat-sheet',
      component: HdPlanetInfluenceCheatSheetPageComponent,
      data: {
        config: {
          id: 'd4e5f678-9012-3456-def0-456789012345',
          name: 'HdPlanetInfluenceCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'iching-cheat-sheet',
      component: HdIchingCheatSheetPageComponent,
      data: {
        config: {
          id: '80038c7d-1f28-4d21-aee9-bca230da2eac',
          name: 'HdIchingCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'not-self-cheat-sheet',
      component: HdNotSelfCheatSheetPageComponent,
      data: {
        config: {
          id: 'f3a8c1e2-5b47-4d9a-8e6f-1c2d3b4a5e60',
          name: 'HdNotSelfCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'conditioning-cheat-sheet',
      component: HdConditioningCheatSheetPageComponent,
      data: {
        config: {
          id: 'a1c4e7b2-9d36-4f58-b0a7-2e5c8d1f4b93',
          name: 'HdConditioningCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'love-gates-cheat-sheet',
      component: HdLoveGatesCheatSheetPageComponent,
      data: {
        config: {
          id: 'e2b8d4f6-3a71-4c95-8d2e-7f4a9c1b6e58',
          name: 'HdLoveGatesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'phs-cheat-sheet',
      component: HdPhsTransformationCheatSheetPageComponent,
      data: {
        config: {
          id: 'a7f3b9c2-4d61-4e8a-9b2f-3c5d6e7a8b90',
          name: 'HdPhsCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'phs-icon-candidates',
      component: HdPhsIconCandidatesPageComponent,
      data: {
        config: {
          id: 'b8e4c0d3-5f72-4a9b-8c3e-4d6f7a8b9c01',
          name: 'HdPhsIconCandidates',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'streams-cheat-sheet',
      component: HdStreamsCheatSheetPageComponent,
      data: {
        config: {
          id: 'c9f2a1b4-7d83-4e15-9a26-1f3b5c7d9e02',
          name: 'HdStreamsCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'cycles-cheat-sheet',
      component: HdCyclesCheatSheetPageComponent,
      data: {
        config: {
          id: 'e5b7d2c8-3a91-4f60-b8d4-7c2e9f1a6b53',
          name: 'HdCyclesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'profile-lines-cheat-sheet',
      component: HdProfileLinesCheatSheetPageComponent,
      data: {
        config: {
          id: 'd6c8e4f2-9b17-4a35-8c60-2e4f7a9b1d84',
          name: 'HdProfileLinesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'role-gates-cheat-sheet',
      component: HdRoleGatesCheatSheetPageComponent,
      data: {
        config: {
          id: 'a3e9f5b1-6c28-4d74-9e83-5b1c8d2f7a96',
          name: 'HdRoleGatesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'profile-roles-cheat-sheet',
      component: HdProfileRolesCheatSheetPageComponent,
      data: {
        config: {
          id: 'f8b2d6a4-1e59-4c87-b3a2-9d6e4f8c1b75',
          name: 'HdProfileRolesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'nodal-lines-cheat-sheet',
      component: HdNodalLinesCheatSheetPageComponent,
      data: {
        config: {
          id: 'b4d8f2a6-7e13-4b59-a8c4-3f9e6d1b8c27',
          name: 'HdNodalLinesCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'communication-cheat-sheet',
      component: HdCommunicationCheatSheetPageComponent,
      data: {
        config: {
          id: 'c7a1e9b3-2d48-4f65-a1c9-8e3d5b7f2a46',
          name: 'HdCommunicationCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'awareness-cheat-sheet',
      component: HdAwarenessCheatSheetPageComponent,
      data: {
        config: {
          id: 'eeddfe20-b130-4698-b8af-f30e6e33a486',
          name: 'HdAwarenessCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'melancholy-cheat-sheet',
      component: HdMelancholyCheatSheetPageComponent,
      data: {
        config: {
          id: '934a116b-60f5-4faf-9723-bb0937a99392',
          name: 'HdMelancholyCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
    {
      path: 'memory-cheat-sheet',
      component: HdMemoryCheatSheetPageComponent,
      data: {
        config: {
          id: 'e19b02b3-bcdb-4ad5-8bd4-a588bf397b61',
          name: 'HdMemoryCheatSheet',
          clickTroughPages: {},
          features: {},
          topic,
        },
      },
    },
  ];
}
